import React from 'react';
import { Grid, Container, Typography, Paper, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import HouseSearching from '../../assets/House_searching.png';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import NotificationsIcon from '@material-ui/icons/Notifications';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Faq from './Faq';
import { decodeToken } from 'utils';
import bgImg from 'assets/img1.JPG'

const useStyles = makeStyles(theme => ({
	root: {
		// padding: "5px 30px",
	},

	leftGrid: {
		marginTop: 50,
		paddingLeft: 30,
		paddingBottom: 50,
		[theme.breakpoints.down('sm')]: {
			marginTop: 20,
		},
	},
	leftGridTitle: {
		fontSize: '2em',
		fontFamily: 'Poppins',
		borderBottom: '6px solid #198754',
		[theme.breakpoints.down('sm')]: {
			fontSize: '23px',
		},
		
	},
	strongTitle: {
		fontSize: '2.1em',
	},
	leftGridBody: {
		marginTop: 40,
		fontSize: '4em',
		fontFamily: 'Poppins',
		[theme.breakpoints.down('sm')]: {
			fontSize: '3.5em',
			textAlign: 'left',
		},
	},
	stepText: {
		color: '#B0A7A7',
		fontFamily: 'Poppins',
	},
	paper: {
		padding: 10,
		maxWidth: 270,
		height: 250,
		backgroundColor: '#E7F8EF',
	},
	paperText: {
		fontFamily: 'Poppins',
		color: '#000',
		textAlign: "center"
	},
	submit: {
		margin: theme.spacing(2, 0, 2),
		backgroundColor: '#198754',
		fontFamily: 'Poppins',
		color: '#fff',
		'&:hover': {
			backgroundColor: '#198754',
			color: '#fff',
			opacity: 0.8,
		},
	},
}));

const Landing = () => {
	const classes = useStyles();
	const history = useHistory();
	const { t } = useTranslation();

	const processes = [
		{
			step: `${t('step-one')}`,
			title: `${t('process-register')}`,
			icon: <PersonAddIcon fontSize='large' className='dark-language-icons' />,
			description: `${t('application-registration')}`,
		},
		{
			step: `${t('step-two')}`,
			title: `${t('process-request')}`,
			icon: <AutorenewIcon fontSize='large' className='dark-language-icons' />,
			description: `${t('automatic-eligibility')}`,
		},
		{
			step: `${t('step-three')}`,
			title: `${t('process-notification')}`,
			icon: (
				<NotificationsIcon fontSize='large' className='dark-language-icons' />
			),
			description: `${t('system-notify')}`,
		},
		{
			step: `${t('step-four')}`,
			title: `${t('process-approved')}`,
			icon: (
				<CheckCircleOutlineIcon
					fontSize='large'
					className='dark-language-icons'
				/>
			),
			description: `${t('eligible-applicants')}`,
		},
	];

	return (
		<div className={`${classes.root}`}>
			<div disableGutters={true}>
				<Grid container justifyContent='space-between' className='body-landing text-light' >
					<Grid item xs={12} sm={12} md={5} className={classes.leftGrid}>
						<Typography className={classes.leftGridTitle}>
							{t('welcome-to')}{' '}
							<strong className={classes.strongTitle}>{t('title')}</strong>
						</Typography>
						<Typography component='p' className={classes.leftGridBody}>
							{t('looking-to')}
						</Typography>
					{!decodeToken()?.id &&	<Button
							variant='contained'
							size='large'
							className={'custom-btn my-4'}
							onClick={() => history.push('/auth')}
						>
							{t('get-started')}
						</Button>}
					</Grid>
					{/* <Grid item md={6} style={{ width: '100%' }}>
						<img src={HouseSearching} alt='house search' width={'100%'} />
					</Grid> */}
				</Grid>
				<Typography
					variant='h4'
					gutterBottom={true}
					style={{
						fontFamily: 'Poppins',
						textAlign: 'center',
						padding: '10px',
						textTransform: 'uppercase',
					}}
					className='mt-5'
				>
					{t('application-process')}
				</Typography>
				<div className="mx-5">
				<Grid
					container
					justifyContent='space-between'
					className='container-center'
					spacing={2}
				>
					{processes.map(({ step, title, icon, description }) => (
						<Grid
							item
							key={step}
							data-aos='zoom-in'
							data-aos-duration='3000'
							style={{ margin: 0 }}
						>
							<Paper className={`${classes.paper}`} elevation={6}>
								<Grid
									container
									direction='column'
									alignItems='center'
									spacing={2}
								>
									<Grid item>
										<Typography className={classes.stepText}>{step}</Typography>
									</Grid>
									<Grid item>
										<Typography  className={classes.paperText}>
											<strong>{title}</strong>
										</Typography>
									</Grid>
									<Grid item>{icon}</Grid>
									<Grid item>
										<label className={classes.paperText}>
											{description}
										</label>
									</Grid>
								</Grid>
							</Paper>
						</Grid>
					))}
				</Grid>
				<div>&nbsp;</div>
				<Grid container>
					<Grid item xs={12} sm={12} md={12}>
						<Faq />
					</Grid>
				</Grid></div>
				<div>&nbsp;</div>
			</div>
		</div>
	);
};

export default Landing;
